import React, {Component, PropTypes} from 'react'
import {Input} from 'react-bootstrap'
import {checkboxField, controlledField} from '../../core/redux/form'
import {phoneField} from '../../core/phonez'
import Icon from '../../core/components/Icon'
import Card from '../../core/components/Card'
import {updateOpenTicketCmd} from '../actions'
import {nameToPlainName, mediumToContactMedium} from '../models'
import i18n from '../i18n'
import style from './OpenTicketContactToCallbackCard.less'

function callerToContactToCallbackCmd(caller) {
    if (caller && caller.callerType == 'HumanCaller') {
        return {
            namez: nameToPlainName(caller.namez),
            medium: caller.medium
        }
    }
    if (caller && caller.callerType == 'ReferencedContactCaller') {
        return caller.uid && {
            namez: nameToPlainName(caller.uid.name),
            medium: mediumToContactMedium(caller.uid.contacts[0])
        }
    }
    return caller
}

class OpenTicketContactToCallbackCard extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        form: PropTypes.func.isRequired,
        cmd: PropTypes.object
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.cmd && nextProps.cmd != this.props.cmd) {
            if (nextProps.cmd.ticket != (this.props.cmd && this.props.cmd.ticket)
                && nextProps.cmd.ticket.callerz != (this.props.cmd && this.props.cmd.ticket && this.props.cmd.ticket.callerz)) {
                const {dispatch, cmd} = nextProps
                const {sameAsCaller} = this.state

                if (sameAsCaller) {
                    const ticket = cmd && cmd.ticket
                    const callerz = cmd && cmd.ticket && cmd.ticket.callerz
                    const contactToCallback = cmd && cmd.ticket && cmd.ticket.contactToCallback

                    var nextContactToCallback = callerToContactToCallbackCmd(callerz)
                    nextContactToCallback = nextContactToCallback && {...contactToCallback, ...nextContactToCallback}
                    dispatch(updateOpenTicketCmd({ticket: {...ticket, contactToCallback: nextContactToCallback}}))
                }
            }
        }
    }

    render() {
        const {dispatch, form, cmd, ...others} = this.props
        const {sameAsCaller} = this.state

        const sameAsCallerField = () => {
            const value = sameAsCaller

            const onChange = (sameAsCaller) => {
                const ticket = cmd && cmd.ticket
                const callerz = cmd && cmd.ticket && cmd.ticket.callerz

                const contactToCallback = sameAsCaller && callerToContactToCallbackCmd(callerz) || null
                dispatch(updateOpenTicketCmd({ticket: {...ticket, contactToCallback}}))

                this.setState({sameAsCaller})
            }

            return {value, onChange}
        }

        const mediumField = (field, type) => {
            const disabled = field.value && field.value.contactMediumType != type || field.disabled
            var value

            switch(type) {
                case 'Phone':
                    value = field.value && field.value.phone
                    break
                case 'Mail':
                    value = field.value && field.value.mail
                    break
                case 'Fax':
                    value = field.value && field.value.fax
                    break
            }

            function onChange(eventOrValue) {
                var value
                if (eventOrValue && eventOrValue.target) {
                    value = eventOrValue.target.value
                } else {
                    value = eventOrValue
                }

                var medium
                switch(type) {
                    case 'Phone':
                        medium = value && {phone: value, contactMediumType: 'Phone'} || null
                        break
                    case 'Mail':
                        medium = value && {mail: value, contactMediumType: 'Mail'} || null
                        break
                    case 'Fax':
                        medium = value && {fax: value, contactMediumType: 'Fax'} || null
                        break
                }

                field.onChange(medium)
            }

            return {...field, disabled, value, onChange}
        }

        const disabledField = (field, disabled) => {
            return {...field, disabled}
        }

        const header = (
            <h5>{i18n.contactToCallback}</h5>
        )

        const inputAddon = (icon) => (
            <Icon icon={icon} size='xs' />
        )

        return (
            <div>
                <Card
                    kind='tab'
                    header={header}
                    {...others}>
                    <div className={style.defaultContent}>
                        <form>
                            <Input
                                type='text'
                                name='name'
                                placeholder={i18n.name + ' *'}
                                disabled={sameAsCaller}
                                {...form.ticket.contactToCallback.namez()} />
                            <Input
                                type='text'
                                name='phone'
                                placeholder={i18n.phone}
                                addonBefore={inputAddon('phone')}
                                disabled={sameAsCaller}
                                {...phoneField(mediumField(disabledField(form.ticket.contactToCallback.medium(), sameAsCaller), 'Phone'))} />
                            <Input
                                type='text'
                                name='email'
                                placeholder={i18n.email}
                                addonBefore={inputAddon('mail')}
                                disabled={sameAsCaller}
                                {...mediumField(disabledField(form.ticket.contactToCallback.medium(), sameAsCaller), 'Mail')} />
                            <Input
                                type='text'
                                name='fax'
                                placeholder={i18n.fax}
                                addonBefore={inputAddon('fax')}
                                disabled={sameAsCaller}
                                {...phoneField(mediumField(disabledField(form.ticket.contactToCallback.medium(), sameAsCaller), 'Fax'))} />
                            <Input
                                type='textarea'
                                name='comment'
                                placeholder={i18n.comment}
                                {...controlledField(form.ticket.contactToCallback.comment())} />
                        </form>
                        <Input
                            type='checkbox'
                            label={i18n.contactToCallbackSameAsCaller}
                            {...checkboxField(sameAsCallerField())} />
                    </div>
                </Card>
            </div>
        )
    }
}

export default OpenTicketContactToCallbackCard


// WEBPACK FOOTER //
// ./lib/ticket/components/OpenTicketContactToCallbackCard.js